import React from "react";

import { Outlet, useLoaderData } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {
  getEndcustomerAccountByEndcustomerAccountID,
  getAllEndcustomerArticles,
  getEndCustomers,
} from "API/swesum";

export async function loader({ params }) {
  const endcustomerAccount = await getEndcustomerAccountByEndcustomerAccountID(
    params.accountID
  );
  const endcustomerArticles = await getAllEndcustomerArticles();
  const endcustomers = await getEndCustomers();

  return { endcustomerAccount, endcustomerArticles, endcustomers };
}

export default function EndcustomerAccount() {
  const { endcustomerAccount } = useLoaderData();

  return (
    <>
      {/* <Drawer menuItems={menuItems}> */}
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            {`Slutkundskonto -`} {endcustomerAccount.Id}
          </Typography>

          <Outlet />
        </Box>
      </Box>
      {/* </Drawer> */}
    </>
  );
}
